import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import CustomLayout from "../../../Core/Layout/CustomLayout";
import Button from "../../../Core/Components/CustomButton";
import SolarIcon from "../../../Common/Svgs/SolarIcon";
import CustomRange from "../../../Core/Components/CustomRange";
import PowerGridIcon from "../../../Common/Svgs/PowerGridIcon";

const StorageControlPanelScreen = () => {
  const navigate = useNavigate();

  const { selectedHub } = useSelector((state) => state.hubs);

  const [solar, setSolar] = useState({
    value: 50,
    startTime: "06:00 AM",
    endTime: "06:00 PM",
  });

  const [grid, setGrid] = useState({
    value: 50,
    startTime: "06:00 AM",
    endTime: "06:00 PM",
  });

  return (
    <CustomLayout pageName={selectedHub?.name || ""} hideFooter>
      <div className="bg-background-white w-full h-full">
        <div className="flex items-center justify-between p-6 border-b border-light-grey">
          <p className="font-poppins text-base font-medium capitalize">
            storage control panel
          </p>

          <div className="flex items-center gap-x-3">
            <Button
              size="filter"
              width="generateUser"
              colors="grey"
              onClick={() => navigate(-1)}
            >
              Cancel
            </Button>

            <Button
              size="filter"
              width="generateUser"
              type="submit"
              onClick={() => navigate(-1)}
            >
              Save
            </Button>
          </div>
        </div>

        <div className="p-6">
          <p className="font-aileron text-xs font-normal">
            Manage how you want the energy distribution in the storage
            inverters.
          </p>

          {/* solar */}
          <div className="mt-6 p-4 w-[448px] bg-background border border-light-grey rounded-md cursor-not-allowed">
            <div className="flex items-center gap-x-2">
              <SolarIcon size={20} />
              <p className="font-poppins font-medium text-base">Solar</p>
            </div>

            <div className="mt-6 flex items-center justify-between">
              <p className="font-aileron text-xs font-normal text-dark-gray">
                Energy percentage
              </p>

              <p className="font-poppins text-xs font-medium">{solar.value}%</p>
            </div>

            <div className="mt-2">
              <CustomRange
                disabled
                current={solar.value}
                onChange={(values) =>
                  setSolar((prev) => ({ ...prev, value: values[0] }))
                }
                baseTrackColor="#DFDFDF"
                activeTrackColor="#FAD152"
                dotColor="#FAD152"
              />
            </div>

            {/* start time and end time */}
            {/* <div className="mt-6 flex items-center justify-between">
              <div>
                <p className="mb-1.5 font-aileron text-xs font-normal text-dark-gray">
                  Start Time
                </p>

                <TimeSelection
                  current={solar.startTime}
                  labelClassName="w-[172px] h-9"
                  dropdownWidth="172px"
                  onSelect={(item) =>
                    setSolar((prev) => ({ ...prev, startTime: item }))
                  }
                />
              </div>

              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="30"
                height="56"
                fill="none"
                viewBox="0 0 30 56"
              >
                <path
                  fill="#DFDFDF"
                  d="M.333 38a2.667 2.667 0 1 0 5.334 0 2.667 2.667 0 0 0-5.334 0m24 0a2.667 2.667 0 1 0 5.334 0 2.667 2.667 0 0 0-5.334 0M3 38v.5h24v-1H3z"
                />
              </svg>

              <div>
                <p className="mb-1.5 font-aileron text-xs font-normal text-dark-gray">
                  End Time
                </p>

                <TimeSelection
                  current={solar.endTime}
                  labelClassName="w-[172px] h-9"
                  dropdownWidth="172px"
                  onSelect={(item) =>
                    setSolar((prev) => ({ ...prev, endTime: item }))
                  }
                />
              </div>
            </div> */}

            {/* <div className="mt-2 flex items-center justify-between">
              <p className="font-aileron text-xs font-normal text-dark-gray">
                Duration
              </p>

              <p className="font-poppins text-xs font-medium">
                {duration(solar.startTime, solar.endTime)}
              </p>
            </div> */}
          </div>

          {/* grid */}
          <div className="mt-6 p-4 w-[448px] bg-background border border-light-grey rounded-md cursor-not-allowed">
            <div className="flex items-center gap-x-2">
              <PowerGridIcon size={20} />
              <p className="font-poppins font-medium text-base">Grid</p>
            </div>

            <div className="mt-6 flex items-center justify-between">
              <p className="font-aileron text-xs font-normal text-dark-gray">
                Energy percentage
              </p>

              <p className="font-poppins text-xs font-medium">{grid.value}%</p>
            </div>

            <div className="mt-2">
              <CustomRange
                disabled
                current={grid.value}
                onChange={(values) =>
                  setGrid((prev) => ({ ...prev, value: values[0] }))
                }
                baseTrackColor="#DFDFDF"
                activeTrackColor="#085054"
                dotColor="#085054"
              />
            </div>

            {/* start time and end time */}
            {/* <div className="mt-6 flex items-center justify-between">
              <div>
                <p className="mb-1.5 font-aileron text-xs font-normal text-dark-gray">
                  Start Time
                </p>

                <TimeSelection
                  current={grid.startTime}
                  labelClassName="w-[172px] h-9"
                  dropdownWidth="172px"
                  onSelect={(item) =>
                    setGrid((prev) => ({ ...prev, startTime: item }))
                  }
                />
              </div>

              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="30"
                height="56"
                fill="none"
                viewBox="0 0 30 56"
              >
                <path
                  fill="#DFDFDF"
                  d="M.333 38a2.667 2.667 0 1 0 5.334 0 2.667 2.667 0 0 0-5.334 0m24 0a2.667 2.667 0 1 0 5.334 0 2.667 2.667 0 0 0-5.334 0M3 38v.5h24v-1H3z"
                />
              </svg>

              <div>
                <p className="mb-1.5 font-aileron text-xs font-normal text-dark-gray">
                  End Time
                </p>

                <TimeSelection
                  current={grid.endTime}
                  labelClassName="w-[172px] h-9"
                  dropdownWidth="172px"
                  onSelect={(item) =>
                    setGrid((prev) => ({ ...prev, endTime: item }))
                  }
                />
              </div>
            </div> */}

            {/* <div className="mt-2 flex items-center justify-between">
              <p className="font-aileron text-xs font-normal text-dark-gray">
                Duration
              </p>

              <p className="font-poppins text-xs font-medium">
                {duration(grid.startTime, grid.endTime)}
              </p>
            </div> */}
          </div>
        </div>
      </div>
    </CustomLayout>
  );
};

export default StorageControlPanelScreen;
